import services from './services.js';
import validate from 'validate';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';

//组件
import Tree from "Tree";

export default {
    mixins: [services],
    components: {
        Tree
    },
    props: {

    },
    data() {
        return {
            ActionManage: false,
            TreeDataList: [], //树级数据
            ManageData: [], //部门的直找经理的数据
            queryEmployName: "" //员工弹窗名称搜索
        };
    },
    created() {

    },
    computed: {

    },
    watch: {

    },
    methods: {
        show() {
            this.ActionManage = true;
            this.queryEmployName = ''
            this.ManageData = []
            this.getEmployee();
        },
        handleNodeClick(value) {
            this.getManager(value)
        },
        handleIconClick() {
            this.getManager(this.queryEmployName, "search");
        },
        ActionEmp(val) {
            this.ShortEmployeeData = val;
        },
        ActionManageClose() {
            this.queryEmployName = "";
            this.ActionManage = false;
        },
        ensureEmployee() {
            // this.ActionEmployee.name = this.ShortEmployeeData.name;
            // this.ActionEmployee.ID = this.ShortEmployeeData.ID;
            this.$emit('selectedStaff', this.ShortEmployeeData); // 向上派发 toggle事件
            this.ActionManage = false;
        }
    },
    mounted() {
        this.$nextTick(() => {
            //this.getEmployee();
        });
    }
};


// WEBPACK FOOTER //
// ./src/common/components/selectStaffDialog/vm.js